var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServicePlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.43838 4.01578C8.36787 3.41142 7.60635 3.06631 7.04997 3.44242C5.19243 4.69812 4 6.64452 4 8.82965C4 11.7074 6.06817 14.1711 9 15.1884V17.0002C9 18.4203 10.3431 19.5716 12 19.5716C13.6569 19.5716 15 18.4203 15 17.0002V15.1884C17.9318 14.1711 20 11.7074 20 8.82965C20 6.64452 18.8076 4.69812 16.95 3.44242C16.3936 3.06631 15.6321 3.41143 15.5616 4.01578L15 8.82965H9L8.43838 4.01578ZM10.5 10.143C10.7761 10.143 11 10.3349 11 10.5716V13.143C11 13.3797 10.7761 13.5716 10.5 13.5716C10.2239 13.5716 10 13.3797 10 13.143V10.5716C10 10.3349 10.2239 10.143 10.5 10.143ZM13.5 10.143C13.7761 10.143 14 10.3349 14 10.5716V13.143C14 13.3797 13.7761 13.5716 13.5 13.5716C13.2239 13.5716 13 13.3797 13 13.143V10.5716C13 10.3349 13.2239 10.143 13.5 10.143Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicePlan);
export default __webpack_public_path__ + "static/media/service-plan.682745ef.svg";
export { ForwardRef as ReactComponent };